import moment from "moment";
import UserIcon from "../images/user.png";
import GroomIcon from "../images/groom.png";
import BrideIcon from "../images/bride.png";

export const formatTimeStampToLocalDateTime = (timeStamp) => {
  if (!timeStamp || !moment(timeStamp).isValid()) {
    return "-";
  }

  return moment.utc(timeStamp).local().format("DD-MMM-YYYY hh:mm a");
};

export const formatDateTime = (date, format = "YYYY-MM-DD") => {
  if (!moment(date).isValid()) {
    return;
  }
  return moment(date).format(format);
};

export const scrollIntoElement = ({
  id,
  behavior = "smooth",
  block = "center",
}) => {
  const element = document.getElementById(id);
  if (element) {
    element.scrollIntoView({
      behavior: behavior,
      block: block,
    });
  }
};

export const getProfileAvatarByGender = (gender) => {
  switch (gender) {
    case "MALE":
      return GroomIcon;
    case "FEMALE":
      return BrideIcon;
    default:
      return UserIcon;
  }
};

export const isPasswordValid = function (password) {
  const numbers = password.replace(new RegExp("[^0-9]", "gm"), "").length;
  const lowercase = password.replace(new RegExp("[^a-z]", "gm"), "").length;
  const uppercase = password.replace(new RegExp("[^A-Z]", "gm"), "").length;
  const specialChars = password.match(/[@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/g);
  let specialCharCount = 0;
  if (specialChars) {
    specialCharCount = specialChars.length;
  }

  const isValid =
    password.length > 7 &&
    uppercase + lowercase > 0 &&
    numbers + specialCharCount > 1;
  const hasMinLength = password.length > 7;
  const hasUpperOrLowercase = uppercase + lowercase > 0;
  const hasSpecialCharacters = numbers + specialCharCount > 1;

  return {
    isValid,
    hasMinLength,
    hasUpperOrLowercase,
    hasSpecialCharacters,
  };
};

export const transformFloatToHumanReadable = (number, fractions = 2) => {
  const formatter = new Intl.NumberFormat("en-US", {
    minimumFractionDigits: fractions,
    maximumFractionDigits: fractions,
  });

  const rounded = formatter.format(number);
  return rounded;
};
